import { makeControlProps, typographyProps, backgroundProps, visibilityProps } from './helper';

const properties = [
  makeControlProps('input', {
    pathValue: 'properties.backendname',
    label: 'Backendname'
  }),
  visibilityProps,
  makeControlProps('items', {
    type: 'collapse',
    label: 'Columns',
  }),
]

const view = [
  {
    selector: '.mbst-bottom-toolbar',
    controls: [
      typographyProps,
      makeControlProps('sizing', {
        label: 'Sizing',
        width: {
          label: 'Width',
          measure: ['px', 'em', '%', 'rem', 'vw', 'vh'],
          pathValue: 'width'
        },
        maxWidth: {
          label: 'Max. Width',
          measure: ['px', 'em', '%', 'rem', 'vw', 'vh'],
          pathValue: 'max-width'
        },
        minWidth: {
          label: 'Min. Width',
          measure: ['px', 'em', '%', 'rem', 'vw', 'vh'],
          pathValue: 'min-width'
        },
        height: {
          label: 'Height',
          measure: ['px', 'em', '%', 'rem', 'vw', 'vh'],
          pathValue: 'height'
        },
        maxHeight: {
          label: 'Max. Height',
          measure: ['px', 'em', '%', 'rem', 'vw', 'vh'],
          pathValue: 'max-height'
        },
        minHeight: {
          label: 'Min. Height',
          measure: ['px', 'em', '%', 'rem', 'vw', 'vh'],
          pathValue: 'min-height'
        },
      }),
      // makeControlProps('position', {
      //   label: 'Position',
      //   position: {
      //     label: 'Position',
      //     pathValue: 'position',
      //     options: [
      //       {
      //         label: 'Auto',
      //         value: 'initial',
      //       },
      //       {
      //         label: 'Relative',
      //         value: 'relative',
      //       },
      //       {
      //         label: 'Absolute',
      //         value: 'absolute',
      //       }
      //     ]
      //   },
      //   coordinates: {
      //     label: 'Coordinates',
      //     measure: ['px', 'em', '%', 'rem', 'auto'],
      //     value: 'top',
      //     options: [
      //       [
      //         {
      //           label: 'Top',
      //           value: 'top',
      //         }
      //       ],
      //       [
      //         {
      //           label: 'Left',
      //           value: 'left',
      //         },
      //         {
      //           label: 'Right',
      //           value: 'right',
      //         },
      //       ],
      //       [
      //         {
      //           label: 'Bottom',
      //           value: 'bottom',
      //         }
      //       ]
      //     ]
      //   }
      //
      // }),
      makeControlProps('spacing', { label: 'Spacing' }),
      makeControlProps('borders', { label: 'Borders' }),
      makeControlProps('corners', { label: 'Corners', pathValue: 'border-radius' }),
      backgroundProps,
      makeControlProps('items', {
        type: 'collapse',
        label: 'Columns',
      })
    ]
  }
]

const actions = []

export default {
  properties,
  view,
  actions
}
